<template>
  <div class="element-wrapper" :class="{ inline, required, error, searchField }">
    <label v-if="label" :class="{ visible: showLabel}">
      {{ label }}
    </label>
    <div class="search-icon" v-if="searchField">
      <i class="icon">search</i>
    </div>
    <textarea ref="area" v-if="$attrs.type == 'textarea'" class="form-control" @input="updateValue" :placeholder="placeholder"
              v-bind="$attrs"></textarea>
    <input ref="input" autocomplete="new-password" v-if="$attrs.type != 'textarea'" class="form-control" @input="updateValue"
           :placeholder="placeholder" @change="updateValue" v-bind="$attrs" @keyup="$emit('keyup', $event)" :value="internalValue" />
    <svg @click.stop="clear()" v-show="canClear" class="icon-clear" width="9" height="9" viewBox="0 0 9 9" fill="#666" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <line x1="1" y1="9" x2="9" y2="1" stroke="#666" stroke-width="1" />
      <line x1="1" y1="1" x2="9" y2="9" stroke="#666" stroke-width="1" />
    </svg>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ""
    },
    inline: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    searchField: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasFocus: false,
      internalValue: ""
    };
  },
  computed: {
    showLabel() {
      return this.label && (this.internalValue && this.internalValue.length > 0)
    },
    placeholder() {
      return this.label + (this.required ? "*" : "");
    },
    canClear() {
      return this.internalValue && ['password', 'text', 'email', 'phone', 'number'].indexOf(this.type) && this.internalValue.length > 0
    }
  },
  methods: {
    updateValue(event) {
      if (this.$attrs.type == "checkbox" && !event.target.checked) {
        this.$emit("input", "");
        return;
      }
      this.internalValue = event.target.value;
      this.$emit("input", event.target.value);
    },
    clear() {
      Vue.set(this, 'internalValue', '')
      this.$emit('input', '')
    },
    focus() {
      if (this.$attrs.type == 'textarea') {
        this.$refs.area.focus()
      } else {
        this.$refs.input.focus()
      }
    }
  },
  mounted() {
    this.internalValue = this.$attrs.value;
  }
};
</script>

<style lang="scss" scoped>
.element-wrapper {
  padding-top: 12px;
  position: relative;

  &.searchField {
    .search-icon {
      position: absolute;
      left: 0;
      top: 16px;

      i {
        font-size: 24px;
      }
    }

    input {
      padding-left: 32px;
    }
  }

  &.inline {
    display: inline-block;
    position: static;
    padding: 0;
    width: 1em;
    height: 1em;
  }

  &.required {
    label:after {
      content: "*";
    }
  }

  &.error label {
    color: hsla(10, 100%, 40%, 1);
  }

  &.error input,
  &.error textarea {
    border-bottom: 1px solid hsla(10, 100%, 40%, 1) !important;
    background-color: hsla(10, 100%, 80%, 0.2)
  }

  label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 0;
    overflow: hidden;
    font-size: 14px;
    line-height: 18px;
    transition: opacity 0.2s ease-in;
    opacity: 0;
    font-weight: 300;
    &.visible {
      width: auto;
      opacity: 1;
    }
  }
  input,
  textarea {
    padding: 0;
    line-height: 22px;
    font-size: 18px;
    height: auto;
    margin-top: 4px;
    width: 100%;
    border: none;
    border-bottom: 1px solid #aaa;
    outline: none;
    transition: all 0.3s ease-in;
    background: transparent;
  }

  input:focus,
  textarea:focus {
    box-shadow: none;
    border-bottom: 1px solid goldenrod;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    background-color: transparent;
    -webkit-text-fill-color: inherit;
    -webkit-box-shadow: none;
    transition: background-color 5000s ease-in-out 0s;
  }

  .icon-clear {
    position: absolute;
    z-index: 10;
    right: 8px;
    top: 20px;
    cursor: pointer;
  }
}
</style>
